/* eslint-disable no-undef */
import type { EventBus, EventBusListener } from '../types/event-bus';

export function createDomEventBus(): EventBus {
  const callbackMap = new Map<EventBusListener<any>, EventListener>();

  return {
    publish: (event) => {
      window.dispatchEvent(new CustomEvent(event.topic, { detail: event }));
    },
    subscribe: (topic, callback) => {
      const eventListener: EventListener = (event) => {
        const { detail } = event as CustomEvent;
        callback(detail);
      };

      window.addEventListener(topic, eventListener);
      callbackMap.set(callback, eventListener);
    },
    unsubscribe: (topic, callback) => {
      const eventListener = callbackMap.get(callback);
      if (eventListener) window.removeEventListener(topic, eventListener);
    },
  };
}
